export default "__VITE_ASSET__0a495012__"